import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { CURRENT_CLIENT_TEMPLATE_VAR } from '@core';
import { IncidentRuleBase, ModelIncidentRule } from '@devices';
import { firstValueFrom, map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ModelIncidentRuleService {
  private http = inject(HttpClient);

  getRules(makerId: string, modelId: string, params: Record<string, string | boolean | number> = {}) {
    return firstValueFrom(
      this.http
        .get<{ count: number; data: ModelIncidentRule[] }>(this.baseUrl(makerId, modelId), { params })
        .pipe(map(response => response.data)),
    );
  }

  getRule(makerId: string, modelId: string, ruleId: string) {
    return firstValueFrom(
      this.http
        .get<{ data: ModelIncidentRule }>(`${this.baseUrl(makerId, modelId)}/${ruleId}`)
        .pipe(map(response => response.data)),
    );
  }

  createRule(makerId: string, modelId: string, body: IncidentRuleBase) {
    return firstValueFrom(
      this.http
        .post<{ data: ModelIncidentRule }>(this.baseUrl(makerId, modelId), body)
        .pipe(map(response => response.data)),
    );
  }

  assignRules(makerId: string, modelId: string) {
    return firstValueFrom(
      this.http.post<void>(`${this.baseUrl(makerId, modelId)}/assign`, {}),
    );
  }

  updateRule(makerId: string, modelId: string, ruleId: string, body: Partial<ModelIncidentRule>) {
    return firstValueFrom(
      this.http
        .put<{ data: ModelIncidentRule }>(`${this.baseUrl(makerId, modelId)}/${ruleId}`, body)
        .pipe(map(response => response.data)),
    );
  }

  deleteRule(makerId: string, modelId: string, ruleId: string) {
    return firstValueFrom(
      this.http.delete(`${this.baseUrl(makerId, modelId)}/${ruleId}`),
    );
  }

  private baseUrl(makerId: string, modelId: string) {
    return `devices/v1/clients/${CURRENT_CLIENT_TEMPLATE_VAR}/device-makers/${makerId}/device-models/${modelId}/incident-rules`;
  }
}
